import store from '@/store';
import {Permission, PermissionRestriction, PermissionServiceInterface} from '@/global/types/permission';
import {RouteLocationAsRelative} from 'vue-router';

const service: PermissionServiceInterface = {
    getRouteByPermissionFail: (
        permission: Permission,
        restriction: null | PermissionRestriction = null,
        query: RouteLocationAsRelative['query'] = {}
    ): RouteLocationAsRelative => {

        const permissions = permission
            ? [permission].concat(store.getters['user/permissions/permissions'])
            : store.getters['user/permissions/permissions'];

        // Check restrictions through each user allowed permission
        for (let i: number = 0; i < permissions.length; i++) {

            if (restriction || store.getters['user/permissions/hasRestriction'](permissions[i])) {

                restriction = restriction ?? store.getters['user/permissions/getRestriction'](permissions[i]) as PermissionRestriction;

                if (restriction.isLoginFailure) {

                    return {name: 'errors.401', query};
                }

                if (
                    restriction.isUserDisabled
                    || restriction.isUserCoreIdEmpty
                    || (false === restriction.isUserTypeAccessAllowed)
                    || (false === restriction.isUserAllowed)
                    || (false === restriction.isUserActive)
                ) {

                    return {name: 'errors.403', params: {error: 'eligibility'}, query};
                }

                if (false === restriction.isUserInSupportedCountry) {

                    return {name: 'errors.403', params: {error: 'eligibility-location'}, query};
                }

                if (restriction.tfaNeedLoginVerification) {

                    // SSO login user failed for (user was not created or found in backend)
                    return {name: 'auth.confirm', query};
                }
            }
        }


        return {name: 'errors.403', params: {error: 'no-permissions'}, query};
    },
    isRestricted(restriction: PermissionRestriction): boolean {

        return !!(restriction.isLoginFailure
            || restriction.isUserDisabled
            || restriction.isUserCoreIdEmpty
            || false === restriction.isUserTypeAccessAllowed
            || false === restriction.isUserAllowed
            || false === restriction.isUserActive
            || false === restriction.isUserInSupportedCountry
            || restriction.tfaNeedLoginVerification);
    }
}

export default service